// src/contexts/pedidos/TaxaEntregaBairroContext.js
import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { adicionarTaxaEntregaBairro, alterarTaxaEntregaBairro, buscarTaxasEntregaBairro, excluirTaxaEntregaBairro } from '../../services/pedidos/TaxaEntregaBairroService';
import TaxaEntregaBairroCad from '../../pages/pedidos/TaxaEntregaBairroCad';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';

const TaxaEntregaBairroContext = createContext();

export const useTaxaEntregaBairro = () => useContext(TaxaEntregaBairroContext);

export const TaxaEntregaBairroProvider = ({ children }) => {
  const [taxasEntregaBairro, setTaxasEntregaBairro] = useState([]);
  const [showModalTaxaEntregaBairro, setShowModalTaxaEntregaBairro] = useState(false);
  const showTaxaEntregaBairroCad = () => setShowModalTaxaEntregaBairro(true);
  const { showAlert } = useAlert();
  const { showMessage } = useMessage();

  const fetchTaxasEntregaBairro = useCallback(async () => {
    try {
      const result = await buscarTaxasEntregaBairro();
      setTaxasEntregaBairro(result || []);
      return result || [];
    } catch (error) {
      console.error('Erro ao buscar taxas de entrega por bairro:', error);
      return [];
    }
  }, []);

  useEffect(() => { fetchTaxasEntregaBairro(); }, [fetchTaxasEntregaBairro]);

  const addTaxaEntregaBairro = async (taxa) => {
    try {
      const result = await adicionarTaxaEntregaBairro(taxa);
      setTaxasEntregaBairro((prev) => [...prev, result]);
      showAlert('Taxa de entrega por bairro adicionada com sucesso!');
      return result;
    } catch (error) {
      showMessage(error?.response?.data || 'Erro ao adicionar taxa de entrega por bairro!', 'danger');
      throw error;
    }
  };

  const updateTaxaEntregaBairro = async (taxa) => {
    try {
      const result = await alterarTaxaEntregaBairro(taxa);
      setTaxasEntregaBairro((prev) => prev.map((item) => item.id === result.id ? result : item));
      showAlert('Taxa de entrega por bairro alterada com sucesso!');
      return result;
    } catch (error) {
      showMessage(error?.response?.data || 'Erro ao alterar taxa de entrega por bairro!', 'danger');
      throw error;
    }
  };

  const deleteTaxaEntregaBairro = async (id) => {
    try {
      await excluirTaxaEntregaBairro(id);
      setTaxasEntregaBairro((prev) => prev.filter((item) => item.id !== id));
      showAlert('Taxa de entrega por bairro excluída com sucesso!');
    } catch (error) {
      showMessage(error?.response?.data || 'Erro ao excluir taxa de entrega por bairro!', 'danger');
      throw error;
    }
  };

  return (
    <TaxaEntregaBairroContext.Provider value={{
      taxasEntregaBairro,
      fetchTaxasEntregaBairro,
      addTaxaEntregaBairro,
      updateTaxaEntregaBairro,
      deleteTaxaEntregaBairro,
      showTaxaEntregaBairroCad,
    }}>
      {children}
      <TaxaEntregaBairroCad show={showModalTaxaEntregaBairro} onHide={() => setShowModalTaxaEntregaBairro(false)} />
    </TaxaEntregaBairroContext.Provider>
  );
};
